import dayjs from 'dayjs'

export const DEFAULT_START_DATE = '1900-01-01' // Or the earliest date in your dataset
export const DEFAULT_END_DATE = dayjs().format('YYYY-MM-DD') // Today's date
